import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function GenerateTab({ navigation }) {
  const [promptText, setPromptText] = useState('');
  const [isPromptError, setIsPromptError] = useState(false);
  const [imageURL, setImageURL] = useState(null);
  const [buttonText, setButtonText] = useState('생성하기');
  const navigate = useNavigate();

  const onChangePromptText = (event) => {
    setPromptText(event.target.value);
  }

  const onPressGenerate = async () => {
    if (promptText === '') {
      return setIsPromptError(true);
    } else {
      setIsPromptError(false);

      setButtonText('생성중...');

      try {
        const response = await axios.post('https://us-central1-art-generator-5a6dd.cloudfunctions.net/image-predict', {
          prompt: promptText
        });

        console.log(response.data.image_url)

        setImageURL(response.data.image_url);
        setButtonText('생성하기');
      } catch (error) {
        console.error(error);
      }
    }
  }

  return (
    <div className="w-full h-screen justify-center items-center overflow-scroll mb-20">

      {/* <p>창을 닫고 그림그려줘라고 입력하세요!</p> */}
      <Header />

      <div className="flex flex-col h-full p-6 mt-4 pb-20">
        <img src="/assets/imgs/example.png" style={{ aspectRatio: 1 / 1, marginBottom: 30 }} />


        {/* white bottom line */}
        {
          isPromptError &&
          <Alert severity="error" sx={{ marginBottom: 4 }}>원하는 그림 텍스트를 입력해주세요!</Alert>
        }

        <TextField
          value={promptText}
          onChange={onChangePromptText}
          focused
          inputRef={input => input && input.focus()}
          className="w-full"
          label="원하는 그림 입력하기"
          multiline
          placeholder='정원, 여자, 일러스트레이션'
        />

        <div className="mt-5" />

        <Button variant="contained" color="primary" className="w-full mt-4" onClick={onPressGenerate}>
          <Typography variant="h6" color="white">
            {buttonText}
          </Typography>
        </Button>

        <div className="mt-5" />

        <Typography variant="h6" className="text-black">생성된 그림</Typography>

        {/* image from url */}
        {/* <img src={imageURL} style={{ aspectRatio: 1 / 1, marginBottom: 30 }} /> */}
        {/* tailwind grid 3x3 image */}
        <div className="grid grid-cols-3 gap-2 mt-2">
          <div className="w-full rounded-md">
            <img className="rounded-md" src="/assets/imgs/digital.webp" style={{ aspectRatio: 1 / 1 }} />
            <Typography variant="caption" className="text-black text-center">디지털 아트</Typography>
          </div>

          <div className="w-full rounded-md">
            <img className="rounded-md" src="/assets/imgs/pencil.webp" style={{ aspectRatio: 1 / 1 }} />
            <Typography variant="caption" className="text-black text-center">스케치</Typography>
          </div>

          <div className="w-full rounded-md">
            <img className="rounded-md" src="/assets/imgs/vangogh.webp" style={{ aspectRatio: 1 / 1 }} />
            <Typography variant="caption" className="text-black text-center">반고흐</Typography>
          </div>

          <div className="w-full rounded-md">
            <img className="rounded-md" src="/assets/imgs/3drender.webp" style={{ aspectRatio: 1 / 1 }} />
            <Typography variant="caption" className="text-black text-center">3D 렌더</Typography>
          </div>

          <div className="w-full rounded-md">
            <img className="rounded-md" src="/assets/imgs/neon.webp" style={{ aspectRatio: 1 / 1 }} />
            <Typography variant="caption" className="text-black text-center">네온</Typography>
          </div>

          <div className="w-full rounded-md">
            <img className="rounded-md" src="/assets/imgs/oil.webp" style={{ aspectRatio: 1 / 1 }} />
            <Typography variant="caption" className="text-black text-center">오일</Typography>
          </div>

        </div>

        <div className="mt-3" />

        <Button onClick={onPressGenerate} variant="contained" style={{ backgroundColor: 'black', color: 'white' }}>
          그림 생성하기
        </Button>

        <Slider
          min={0}
          max={5}
          defaultValue={1}
          aria-label="Default"
          valueLabelDisplay="auto" />
      </div>

      <BottomNav />
    </div>
  )
}